/**
 * 注意：
 * 点击事件防抖
 * 使用方法如下：
 * v-preventReClick="time" time 为时间 不传默认3000
 */

// 防止重复提交指令
const preventReClick = {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  }
};

export default preventReClick;
